import { registerPlugin } from '@capacitor/core';
import { withBridgedStackTrace } from '../withBridgedStackTrace';

import type { ApplePencilPlugin } from './definitions';
import { CAPACITOR_APPLE_PENCIL_PLUGIN_NAME } from '../pluginConstants';

const ApplePencilRaw = registerPlugin<ApplePencilPlugin>(CAPACITOR_APPLE_PENCIL_PLUGIN_NAME);
const ApplePencil = withBridgedStackTrace(ApplePencilRaw, CAPACITOR_APPLE_PENCIL_PLUGIN_NAME);

export * from './definitions';
export { ApplePencil };
